<template>
  <admin-layout>
    <h2>{{ t('Statistics') }}</h2>

    <div class="dark:bg-gray-800 h-screen">
      <div
        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 pb-8 pt-4 mx-auto"
      >
        <div
          title="All countributed components"
          class="flex flex-col justify-center items-center gap-2 border-2 border-dashed border-gray-500/50 p-4 rounded-md h-32 dark:text-gray-200"
        >
          <div class="flex gap-2 items-center">
            <span class="font-bold text-3xl md:text-4xl">
              {{ stats.orders }}
            </span>
            <svg
              class="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
              ></path>
            </svg>
          </div>
          <span class="font-semibold text-sm text-center">
            {{ t('Requests') }}
          </span>
        </div>

        <div
          title="Users got help"
          class="flex flex-col justify-center items-center gap-2 border-2 border-dashed border-gray-500/50 p-4 rounded-md h-32 dark:text-gray-200"
        >
          <div class="flex gap-2 items-center">
            <span class="font-bold text-3xl md:text-4xl">
              {{ stats.clients }}
            </span>
            <svg
              class="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
              ></path>
            </svg>
          </div>
          <span class="font-semibold text-sm text-center">
            {{ t('Clients') }}
          </span>
        </div>

        <div
          title="Total favorites received on components"
          class="flex flex-col justify-center items-center gap-2 border-2 border-dashed border-gray-500/50 p-4 rounded-md h-32 dark:text-gray-200"
        >
          <div class="flex gap-2 items-center">
            <span class="font-bold text-3xl md:text-4xl">{{ stats.projects }}</span>
            <svg
              class="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
              ></path>
            </svg>
          </div>
          <span class="font-semibold text-sm text-center">
            {{ t('Projects') }}
          </span>
        </div>

        <div
          title="component views"
          class="md:col-start-2 lg:col-auto flex flex-col justify-center items-center gap-2 border-2 border-dashed border-gray-500/50 p-4 rounded-md h-32 dark:text-gray-200"
        >
          <div class="flex gap-2 items-center">
            <span class="font-bold text-3xl md:text-4xl">{{ stats.partners }}</span>
            <svg
              class="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              ></path>
            </svg>
          </div>
          <span class="font-semibold text-sm text-center">
            {{ t('Partners') }}
          </span>
        </div>
      </div>
    </div>
  </admin-layout>
  <!-- <admin-layout></admin-layout> -->
</template>

<script lang="ts" setup>
import axiosApiClient from '@/axios';
import { onMounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n';

const t = useI18n().t;

onMounted(() => {
  fetchStats();
});

const stats = reactive({
  users: 0,
  products: 0,
  orders: 0,
  revenue: 0,
  clients: 0,
  suppliers: 0,
  projects: 0,
  categories: 0,
  partners: 0,
});

const fetchStats = async () => {
  const clients = await axiosApiClient.get('/api/stats/clients');
  stats.clients = clients.data.stats;

  const projects = await axiosApiClient.get('/api/stats/projects');
  stats.projects = projects.data.stats;

  const partners = await axiosApiClient.get('/api/stats/partners');
  stats.partners = partners.data.stats; 

  const orders = await axiosApiClient.get('/api/stats/requests');
  stats.orders = orders.data.stats;
  
};
</script>

<style lang="scss" scoped></style>
